import { TrashAltIcon } from "assets/icons";
import { Icon } from "ui";

import { DeleteCellProps } from "../InventoryBoxesQrsTable.types";

import styles from "../InventoryBoxesQrsTable.module.scss";

const DeleteBtnCell = ({ boxQrItem, onDeleteClick }: DeleteCellProps) => {
  return (
    <div className={styles.qrsTable_btnCell}>
      <Icon
        as={TrashAltIcon}
        type={"button"}
        color="red"
        className={styles.deleteBtn}
        boxSize={24}
        onClick={() => onDeleteClick(boxQrItem.id)}
      />
    </div>
  );
};

export default DeleteBtnCell;
